import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RelatieTypeComponent } from './relatie-type.component';
import { AddRelatieTypeComponent } from './add-relatie-type/add-relatie-type.component';
import { EditRelatieTypeComponent } from './edit-relatie-type/edit-relatie-type.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        RelatieTypeComponent,
        AddRelatieTypeComponent,
        EditRelatieTypeComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [RelatieTypeComponent],
})
export class RelatieTypeModule { }
